import boletaApi from "./boletaApi";

export const updateUserCompanyStatus = async (body) => {
  try {
    return await boletaApi.post("/updateUserCompanyStatus", body);
  } catch (error) {
    const { response } = error;
    return response;
  }
};
